const bhutan = {
  slug: "bhutan",
  name: "Bhutan",
  hero: {
    overline: "TrekPanda presents · 6 nights / 7 days",
    lines: [
      { text: "Bhutan —" },
      { text: "where ", accent: "happiness" },
      { text: "is a country." },
    ],
    subcopy:
      "Seven days across Bhutan — Thimphu, Punakha and Paro — with a small group and a TrekPanda trip captain, ending on a cliff edge at Tiger's Nest. Join from Bagdogra, or fly in with our flight-inclusive packages. Leave your dates, our travel expert calls you within 24 hours.",
    meta: ["₹30,900 + taxes / person", "New batch every Sunday", "Small groups only"],
    image: "https://images.pexels.com/photos/17898806/pexels-photo-17898806.jpeg?auto=compress&cs=tinysrgb&w=1920",
    imageAlt: "Tiger's Nest monastery on a cliff above Paro valley, Bhutan",
  },
  quickFacts: [
    { icon: "calendar", label: "Duration", value: "6 nights / 7 days" },
    { icon: "footprints", label: "Pace", value: "Easy · all fitness levels" },
    { icon: "users", label: "Age group", value: "7 to 60 years" },
    { icon: "mappin", label: "Starts at", value: "Bagdogra · every Sunday" },
  ],
  marquee: [
    "Tiger's Nest at dawn",
    "Thimphu's quiet streets",
    "108 chortens at Dochula",
    "Punakha Dzong by the river",
    "Gross National Happiness",
    "Butter tea & mountain air",
  ],
  story: {
    overline: "Why Bhutan, why us",
    headingPlain: "We don't do rush.",
    headingAccent: "Especially not here.",
    paragraphs: [
      "Bhutan measures wealth in Gross National Happiness, and it shows — in the prayer flags over every pass, the chilli-laden meals shared family-style, and valleys that have never heard a honk.",
      "TrekPanda has spent years perfecting one route through the kingdom: Thimphu's calm, Punakha's riverside fortress, and the cliff-hanging Tiger's Nest. Flights and permits confuse everyone the first time — so we handle that part.",
    ],
    image: "/bhutan-batch-paro-dzong.webp",
    imageAlt: "A TrekPanda Bhutan batch dressed in traditional kiras and ghos, posing in front of Paro Dzong",
    caption: "Our batch in kiras & ghos, Paro Dzong",
  },
  itinerary: {
    overline: "The route, day by day",
    headingPlain: "Seven chapters,",
    headingAccent: "one kingdom.",
    intro:
      "Starts and ends at Bagdogra / NJP, so cheap trains and flights from anywhere in India work. Every transfer, stay and permit is on us — you just walk, eat and stare.",
    days: [
      {
        n: "01",
        title: "Bagdogra to Phuentsholing",
        kicker: "Entering the Kingdom",
        text: "Our team greets you at Bagdogra Airport and drives you to Phuentsholing, Bhutan's bustling border town. Past Hashimara, the first Himalayan foothills appear — and we handle your Bhutan entry permit so you cross into the kingdom without delay.",
        tags: ["Airport pickup", "Permit formalities", "Dinner included"],
      },
      {
        n: "02",
        title: "Phuentsholing to Thimphu",
        kicker: "The Enchanting Capital",
        text: "After breakfast and immigration formalities, one of the most scenic drives of the trip: Kharbandi Gompa monastery with panoramic valley views, and Chuzom Bridge where the Paro and Wangchu rivers meet. Lunch in Paro en route, then Thimphu's cafes, markets and nightlife by evening.",
        tags: ["Kharbandi Gompa", "Chuzom Bridge", "Thimphu nightlife"],
      },
      {
        n: "03",
        title: "Thimphu to Punakha",
        kicker: "Buddhas & 108 Stupas",
        text: "Morning with the 54-metre Buddha Dordenma and the interactive Simply Bhutan museum, a photo stop at the Tashichho Dzong viewpoint, then over Dochula Pass at 10,200 ft — 108 memorial stupas against snow-capped peaks. End the day on Bhutan's longest suspension bridge over the Mo Chu–Po Chu confluence.",
        tags: ["Buddha Dordenma", "Dochula Pass", "Suspension bridge"],
      },
      {
        n: "04",
        title: "Punakha to Paro",
        kicker: "The Fortress Day",
        text: "Explore Punakha Dzong, Bhutan's most magnificent fortress-monastery at the meeting of two rivers. Then a scenic drive west to Paro with a lunch stop, and an evening browsing Paro Market's handicrafts, local delicacies and live music.",
        tags: ["Punakha Dzong", "Paro Market", "Scenic drive"],
      },
      {
        n: "05",
        title: "Tiger's Nest Monastery Hike",
        kicker: "The Signature Day",
        text: "The unforgettable moderate hike to Paro Taktsang at 3,120 m — the monastery clinging to a cliff edge, home to a sacred statue of Guru Rinpoche. Rest in the afternoon, then soothe your legs with an optional traditional hot stone bath in the evening.",
        tags: ["3,120 m cliff hike", "Hot stone bath (optional)", "Carry water & snacks"],
      },
      {
        n: "06",
        title: "Paro to Phuentsholing",
        kicker: "The Long Way Back",
        text: "Begin at the Paro Airport viewpoint for that famous valley panorama, stop at the historic Tamchog Zam iron bridge over the Paro Chhu, and pause again at the Chuzom confluence. Evening free in Phuentsholing's markets for souvenirs and handicrafts.",
        tags: ["Airport viewpoint", "Tamchog iron bridge", "Souvenir shopping"],
      },
      {
        n: "07",
        title: "Phuentsholing to Bagdogra",
        kicker: "Nadaselpey — Goodbye",
        text: "One last Bhutanese breakfast, then the transfer to Bagdogra Airport, arriving around 1:30–2:00 PM. Book any onward flight after 3:30 PM — and carry the Land of the Thunder Dragon home with you.",
        tags: ["Breakfast included", "Airport transfer", "Fly after 3:30 PM"],
      },
    ],
  },
  parallax: {
    image: "https://images.pexels.com/photos/32261522/pexels-photo-32261522.jpeg?auto=compress&cs=tinysrgb&w=1920",
    imageAlt: "Himalayan peaks under twilight skies in Bhutan",
    quote1: "The mountains here don't shout.",
    quote2: "They whisper, and you lean in.",
  },
  batches: {
    overline: "Upcoming group departures",
    headingPlain: "Pick your",
    headingAccent: "Sunday.",
    intro:
      "A fresh group leaves Bagdogra every Sunday. Flying from Mumbai? Flight-inclusive departures on 27 Sep, 20 Dec and 27 Dec are listed below.",
    weeklyLabel: "Sunday to Saturday · 6N / 7D",
    weeklyWeekday: 0,
    landPrice: "₹30,900",
    landNote: "+ taxes / person",
    flights: {
      overline: "With flights from Mumbai",
      headingPlain: "Fly in,",
      headingAccent: "land happy.",
      note: "Mumbai return flights included · 6N / 7D",
      list: [
        { start: "2026-09-27", price: "₹55,000", tag: "With flights" },
        { start: "2026-12-20", price: "₹60,000", tag: "Christmas week" },
        { start: "2026-12-27", price: "₹60,000", tag: "New Year week" },
      ],
    },
  },
  pricing: {
    overline: "No fine print games",
    headingPlain: "What's in, what's out —",
    headingAccent: "said plainly.",
    image: "/bhutan-cultural-evening.jpg",
    imageAlt: "TrekPanda travellers with Bhutanese hosts during a traditional cultural evening",
    label: "All-in land package",
    price: "₹30,900",
    note: "per person + applicable taxes, joining from Bagdogra. Group batches depart every Sunday. With flights from Mumbai from ₹55,000 — December departures at ₹60,000.",
    included: [
      "6 nights in 3-star hotels across Phuentsholing, Thimphu, Punakha & Paro",
      "Bagdogra airport pickup & drop, all transfers",
      "Daily breakfast and dinner",
      "Bhutan visa, entry permit & SDF charges",
      "Experienced TrekPanda trip captain with first aid",
      "All sightseeing as per the itinerary",
    ],
    excluded: [
      "Flights or trains to Bagdogra",
      "Entry tickets to monuments & museums",
      "Lunches and personal snacks",
      "Hot stone bath and personal expenses",
      "Travel insurance",
    ],
  },
  reviews: {
    overline: "Word of mouth",
    headingPlain: "Don't take our word.",
    headingAccent: "Take theirs.",
    intro: "Every batch comes back with stories. Here's what recent Bhutan travellers told us when they got home.",
    items: [
      {
        quote: "Did Bhutan trip with TrekPanda which was led by Jimmy. Had a really great time, well coordinated and good arrangements by the team including hotels and food. Jimmy also coordinated very well with the group regarding the schedule which gave a clear idea of the things.",
        name: "Chetna Redekar",
        meta: "Google review · Bhutan batch",
      },
      {
        quote: "Joined Bhutan trip with my cousin sister. I loved a lot. Beautiful country. Guides were very helpful — Mr. Wangchuk, Chador and Pasa took care of our group like family members. Nice stay and yummy food every meal. Will suggest to take Bhutan trip.",
        name: "Jigna Pandya",
        meta: "Google review · Bhutan batch",
      },
      {
        quote: "From the Bagdogra pickup to the hot stone bath in Paro, every single detail was sorted. Bhutan with TrekPanda is honestly a cheat code.",
        name: "Sneha & Arjun Kulkarni",
        meta: "Mumbai · December 2025 batch",
      },
      {
        quote: "Went solo, slightly nervous. Came home with fourteen new friends and a camera roll I still scroll through. Book it, don't overthink it.",
        name: "Ankit Sharma",
        meta: "Delhi · January 2026 batch",
      },
    ],
  },
  faqs: [
    {
      q: "Do Indians need a visa for Bhutan?",
      a: "No visa needed. Indians get an entry permit at Phuentsholing with an original passport or voter ID — our team handles the entire permit process for you on Day 1.",
    },
    {
      q: "Can I join with flights from my city?",
      a: "Yes. Join the group at Bagdogra for ₹30,900 + taxes, or fly from Mumbai on our flight-inclusive departures — 27 Sep at ₹55,000, 20 Dec and 27 Dec at ₹60,000. From any other city, our team builds a flight-inclusive quote on the callback.",
    },
    {
      q: "What kind of hotels are included?",
      a: "Comfortable 3-star hotels on twin sharing across Phuentsholing, Thimphu, Punakha and Paro — clean rooms, warm hosts, and locations that keep drives short.",
    },
    {
      q: "I'm travelling solo. How will I be accommodated?",
      a: "Most of our batches have solo travellers. You share a twin room with a same-gender traveller from the group, or opt for a private room at a supplement — just tell our team on the call.",
    },
    {
      q: "Are SDF and permit charges included in ₹30,900?",
      a: "Yes — visa, entry permit and Sustainable Development Fee (SDF) charges are all covered in the package price. No surprise add-ons when you land.",
    },
    {
      q: "What currency works in Bhutan?",
      a: "The Bhutanese Ngultrum is pegged 1:1 to the Indian Rupee, and Indian currency is widely accepted everywhere. Carry some cash for markets and cafes.",
    },
    {
      q: "Is vegetarian food available?",
      a: "Yes — every meal. Bhutanese kitchens do excellent veg dishes, and your trip captain makes sure veg and Jain preferences are sorted at every stop.",
    },
    {
      q: "What ID proofs should I carry?",
      a: "An original passport or voter ID is mandatory for the Bhutan entry permit. Carry 2-3 passport-size photos and photocopies as backup — we guide you through everything.",
    },
    {
      q: "Is Bhutan safe for solo female travellers?",
      a: "Bhutan is consistently ranked among the safest countries in the world, and our trip captain travels with the group from Bagdogra to Bagdogra with 24/7 support.",
    },
  ],
};

export default bhutan;
